import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// components
import { StyledTabsMui } from '../../../../components/tabs-mui';
// features
import { startPivotTable } from '../../../pivot-table/actions';
import { makeSelectPivotTableTotalCount } from '../../../pivot-table/selectors';
import { setExpandedContainerOptions } from '../../../expanded-container/actions';
import PivotTableWrapper from '../../../pivot-table/components/pivot-table-wrapper';
import {
  makeSelectAvailableReferenceTypesByScope,
  makeSelectAllAvailableReferenceTypesByScopeName,
} from '../../../reference/selectors';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// feature dispatch-report/order
import { getTabs } from '../helpers';
import { startCloByTel } from '../actions';
//////////////////////////////////////////////////

const PivotLoad = (props) => {
  const {
    activeTab,
    startCloByTel,
    handleSetActiveTab,
    pivotTableTotalCount,
    setExpandedContainerOptions,
  } = props;

  const handleClickTab = (tabIndex) => {
    if (R.equals(tabIndex, 0)) G.goToRoute(GC.ROUTE_PATH_CLO_REPORT_LIST);

    if (R.equals(tabIndex, 1)) startCloByTel();

    handleSetActiveTab(tabIndex);
  };
  const customTitleComponent = (
    <StyledTabsMui
      activeTab={activeTab}
      tabs={getTabs(activeTab)}
      count={pivotTableTotalCount}
      setActiveTab={handleClickTab}
    />
  );

  return (
    <PivotTableWrapper
      {...props}
      tabs={customTitleComponent}
      relativeFlexStyles={{ paddingTop: 15 }}
      additionalCellActions={[{
        [GC.FIELD_LABEL]: G.getWindowLocale('actions:open-order-details', 'Open Order Details'),
        action: ({ recordId }) => {
          setExpandedContainerOptions({
            opened: true,
            visitPageGuid: R.head(recordId),
            options: { fromPivotTable: true },
            componentType: GC.PAGE_DISPATCH_DETAILS_NEW_ORDER,
          });
        },
      }]}
    />
  );
};

const mapStateToProps = (state) => createStructuredSelector({
  refList: makeSelectAvailableReferenceTypesByScope(state),
  pivotTableTotalCount: makeSelectPivotTableTotalCount(state),
  allAvailableRefTypesByScopeName: makeSelectAllAvailableReferenceTypesByScopeName(state),
});

export default connect(mapStateToProps, {
  startCloByTel,
  startPivotTable,
  setExpandedContainerOptions,
})(PivotLoad);
